/** Sort tab keys for UI/i18n; API receives uppercase via `normalizeProjectsSort`. */
export const projectsSortItems: string[] = [
  'newest',
  'oldest',
  'titleAsc',
  'titleDesc',
];

/** Normalizes sort query values to API uppercase (e.g. `NEWEST`, `TITLEASC`). */
export function normalizeProjectsSort(value: string): string {
  return value.toUpperCase();
}
